import Resource from './Resource';

class FileFolder extends Resource {
	constructor() {
		super('fileFolders');
	}

	changeFileFolder = async (id: number, folderId: number | null) =>
		this._putRequest(`changeFileFolder/${id}/${folderId}`, {
			methodName: 'changeFileFolder'
		}).then((response: { data: unknown }) => response.data);
}

export default new FileFolder();
